import * as React from 'react';

import * as dompurify from 'dompurify';

import { injectCastleRequestToken } from '@ReactComponents/../utils/castle';
import { RedesignedLoginForm } from '@ReactComponents/RedesignedLoginForm/RedesignedLoginForm';
import { EmburseAccountsPageContainer } from '@ReactComponents/Shared/Account/EmburseAccountsPageContainer';

import { WindowErrors } from './loginHelper';

import * as style from './LoginPage.styl';

// @ts-ignore https://github.com/cure53/DOMPurify/issues/1034
const sanitize = dompurify.default?.sanitize || dompurify.sanitize;

interface ILoginPageProps {
  csrf: string;
  locals: WindowErrors;
}

export const LoginPage: React.FC<ILoginPageProps> = ({ csrf, locals }) => {
  const createErrorDiv = (className: string, html: string) => {
    const sanitized = sanitize(html); // this should be serverside html
    return <div className={className} dangerouslySetInnerHTML={{ __html: sanitized }} />;
  };

  const renderErrors = () => {
    let ele;
    if (locals?.error && locals.error.length) {
      ele = createErrorDiv('error', locals.error);
    } else if (locals?.flashError && locals.flashError.length > 0) {
      ele = createErrorDiv('error', locals.flashError);
    } else if (locals?.flashSuccess && locals.flashSuccess.length > 0) {
      ele = createErrorDiv('flashSuccess', locals.flashSuccess);
    }
    return ele;
  };

  function onSubmit(e: any) {
    injectCastleRequestToken(e);
    e.nativeEvent.submitter.disabled = true;
    setTimeout(() => {
      e.nativeEvent.submitter.disabled = false;
    }, 2000); // in case of an unexpected error (e.g network issue), allows the form to be submitted again after a short delay
  }

  return (
    <div className={style.global}>
      <div className="onboardingWrapper">
        {renderErrors()}
        <EmburseAccountsPageContainer>
          <RedesignedLoginForm csrf={csrf} onSubmit={onSubmit} />
        </EmburseAccountsPageContainer>
      </div>
    </div>
  );
};
